import { DEFAULT_CONFIG, MARKET_CONFIG_OVERRIDES } from '../constants/marketConfigurations';

export const getPropOrDefault = (prop, defaultValue) => prop || defaultValue;

export const buildMarketConfig = (locale) => {
  const marketConfig = MARKET_CONFIG_OVERRIDES[locale] || {};
  return {
    ...DEFAULT_CONFIG,
    ...marketConfig,
  };
};

export default buildMarketConfig;
